import React, {useState, useEffect, useRef} from 'react'
import styled from 'styled-components'
import Header from '../../components/Header/Header'
import {fetchKioskEquipment} from '../../api/kiosk'
import KioskEquipment from '../../components/KioskEquipment/KioskEquipment'
import KioskEquipmentHeader from '../../components/KioskEquipment/KioskEquipmentHeader'
import Confirm, {CONFIRM_YES} from '../../components/Confirm/Confirm'
import {DASHBOARD} from '../../constants/const'
import {useUIDispatch} from '../../context/UIContext'
import {_L, useLocaleState} from '../../context/LocaleContext'
import HeaderButton from '../../components/Header/HeaderButton'
import HeaderTitle from '../../components/Header/HeaderTitle'

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #f3f5fb;
  box-sizing: border-box;
`

const ListContainer = styled.div`
  height: calc(100vh - 80px);
  width: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  background-color: #f3f5fb;
  padding: 10px;
`
const RegisterKiosk = () => {
  const [kioskEquipment, setKioskEquipment] = useState([])
  const [showConfirm, setShowConfirm] = useState(false)
  const [showReloadConfirm, setShowReloadConfirm] = useState(false)
  const localeState = useLocaleState()
  const uiDispatch = useUIDispatch()

  let kioskInfo = useRef(null)

  useEffect(() => {
    let isMounted = true
    fetchKioskEquipment().then(equipment => {
      if (isMounted) {
        setKioskEquipment(equipment)
      }
    })

    return () => {
      isMounted = false
    }
  }, [])

  const onCancel = () =>
    uiDispatch({type: 'setContent', payload: {content: DASHBOARD}})

  const onRegister = ({eqId, blId, flId, rmId, eqStd}) => {
    let storageItem = {
      eq_id: eqId,
      bl_id: blId,
      fl_id: flId,
      rm_id: rmId,
      eq_std: eqStd
    }

    kioskInfo.current = storageItem
    setShowConfirm(true)
  }

  const onConfirm = response => {
    if (response === CONFIRM_YES) {
      if (kioskInfo.current) {
        window.localStorage.setItem(
          'archibus_kiosk_id',
          JSON.stringify(kioskInfo.current)
        )
        setShowReloadConfirm(true)
      }
    }
    kioskInfo.current = null
    setShowConfirm(false)
  }

  const onReloadConfirm = response => {
    if (response === CONFIRM_YES) {
      window.location.reload()
    }
    setShowReloadConfirm(false)
  }

  const onCloseConfirm = () => {
    kioskInfo.current = null
    setShowConfirm(false)
    setShowReloadConfirm(false)
  }

  let confirmMessage = _L({
    key: 'Would you like to register your device as Kiosk ',
    localeState
  })
  confirmMessage += kioskInfo.current
    ? kioskInfo.current.eq_id + _L({key: '?', localeState})
    : ''

  return (
    <Container>
      <Header
        centerContent={
          <HeaderTitle title={_L({key: 'Register Kiosk', localeState})} />
        }
        rightContent={
          <HeaderButton
            onClick={onCancel}
            label={_L({key: 'Cancel', localeState})}
          />
        }
      />
      <ListContainer>
        <KioskEquipmentHeader />
        {kioskEquipment.map(equipment => (
          <KioskEquipment
            key={equipment.eqId}
            equipment={equipment}
            onClick={onRegister}
          />
        ))}
      </ListContainer>
      <Confirm
        isOpen={showConfirm}
        onConfirm={onConfirm}
        onClose={onCloseConfirm}
        title={_L({key: 'Register Device', localeState})}
        message={confirmMessage}
      />
      <Confirm
        isOpen={showReloadConfirm}
        onConfirm={onReloadConfirm}
        onClose={onCloseConfirm}
        title={_L({key: 'Confirm Refresh', localeState})}
        message={_L({
          key:
            'The device has been registered. Do you want to refresh the page?.',
          localeState
        })}
      />
    </Container>
  )
}

export default RegisterKiosk
